<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.handover_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/handover/handover';
  import { mapGetters } from 'vuex';
  import { getSpaceTree } from '@/api/v4ward/car/carparkspace';


  export default {
    data() {
      return {
        form: {},
        query: {},
        spaceList: [],
        tempParkingLotId: '',
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        reWrite: false,
        selectionList: [],

        option: {
          tip: false,
          tree: true,
          searchShow: true,
          searchMenuSpan: 6,
          height: 'auto',
          //calcHeight: 30,
          border: true,
          index: true,
          indexLabel: '序号',
          viewBtn: true,
          labelWidth: 180,
          selection: true,
          columnBtn: false,
          refreshBtn: false,
          align: 'center',
          column: [

            {
              label: '车场名称',
              prop: 'parkingLotId',
              type: 'tree',
              //dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
              editDisabled: true,
              search: true,
              searchSpan: 5,
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
              rules: [
                {
                  required: true,
                  message: '请选择车场',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '接班时间',
              prop: 'shiftStart',
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              width: 140,
              rules: [
                {
                  required: true,
                  message: '请输入接班时间',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '交班时间',
              prop: 'shiftEnd',
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              width: 140,
              rules: [
                {
                  required: true,
                  message: '请输入交班时间',
                  trigger: 'change',
                },
                {
                  validator: (rule, value, callback) => {
                    var startshift = Date.parse(this.form.shiftStart);
                    var endshift = Date.parse(value);
                    if (startshift >= endshift) {
                      callback(new Error('交班时间必须大于接班日期！'));
                    } else {
                      callback();
                    }
                  },
                  trigger: 'change',
                },
              ],
            },
            {
              label: '当班总应收金额',
              prop: 'shiftTotalAmount',
              maxlength: 10,
              showWordLimit: true,
              mock: {
                type: 'number',
                max: 1,
                min: 2,
                precision: 2,
              },
              rules: [
                {
                  required: true,
                  message: '请输入当班总应收金额',
                  trigger: 'change',
                },
                { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },

              ],
              minRows: 0.01,
            },
            {
              label: '当班总实收金额',
              prop: 'shiftActualAmount',
              maxlength: 10,
              showWordLimit: true,
              mock: {
                type: 'number',
                max: 1,
                min: 2,
                precision: 2,
              },
              rules: [
                {
                  required: true,
                  message: '请输入当班总实收金额',
                  trigger: 'change',
                },
                { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
              ],
              minRows: 0.01,

            },
            {
              label: '未收金额',
              prop: 'shiftOutflowAmount',
              maxlength: 10,
              showWordLimit: true,
              mock: {
                type: 'number',
                max: 1,
                min: 2,
                precision: 2,
              },
              rules: [
                {
                  required: true,
                  message: '请输入未收金额',
                  trigger: 'change',
                },
                { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
              ],
              minRows: 0.01,
            },
            {
              label: '当班人ID',
              prop: 'shiftUserId',
              rules: [{
                required: true,
                message: '请输入当班人ID',
                trigger: 'change',
              }],
              hide: true,
            },
            {
              label: '当班人账号',
              prop: 'shiftAccount',
              rules: [{
                required: true,
                message: '请输入当班人账号',
                trigger: 'change',
              }],
            },
            {
              label: '当班人姓名',
              prop: 'shiftUsername',
              rules: [{
                required: true,
                message: '请输入当班人姓名',
                trigger: 'change',
              }],
            },
            {
              label: '备注信息',
              prop: 'remark',
              type: 'textarea',
              minRows: 2,
              maxlength: 100,
              showWordLimit: true,
              overHidden: true,
              hide: true,
              rules: [
                {
                  required: false,
                  message: '请输入备注信息',
                  trigger: 'change',
                },
              ],
            },

          ],
        },
        data: [],
      };
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.handover_add, false),
          viewBtn: this.vaildData(this.permission.handover_view, true),
          delBtn: this.vaildData(this.permission.handover_delete, true),
          editBtn: this.vaildData(this.permission.handover_edit, false),
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    watch: {
      'form.parkingLotId'() {
        this.loadPassageSelections(this.form.parkingLotId);
        this.form.passageId = '';
      },
    },
    created() {
      getSpaceTree().then((data) => {
        this.spaceList = data.data;
        if (this.spaceList.length > 0) {
          var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
          spaceColumn.dicData = data.data;
          spaceColumn.searchValue = this.spaceList[0].id;
          this.query.parkingLotId = this.spaceList[0].id;
          this.tempParkingLotId = this.spaceList[0].id;
          this.$nextTick(() => {
            this.reWrite = true;
          });
        } else {
          this.$nextTick(() => {
            this.reWrite = true;
          });
        }
        this.onLoad();
      });
    },
    methods: {
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: row.id });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (['edit', 'view'].includes(type)) {
          getDetail({ id: this.form.id }).then(({ data }) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        this.query = {};
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="车场名称"]');
              ent.value = this.spaceList[0].title;
              this.query.parkingLotId = this.spaceList[0].id;
              //关闭默然显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          },
        );
      },
    },
  };
</script>

<style>
</style>
